import { render, staticRenderFns } from "./tower.vue?vue&type=template&id=0a504bc7"
import script from "./tower.vue?vue&type=script&lang=js"
export * from "./tower.vue?vue&type=script&lang=js"
import style0 from "./tower.vue?vue&type=style&index=0&id=0a504bc7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports